<template>
  <div class="repairTrace-container repairPage-container">
    <div class="repairTrace-header" v-if="currentToken">
      <div></div>
      <el-button
        type="text"
        icon="el-icon-user-solid"
        @click="clearStorage"
        class="repairTrace-logou"
        >退出当前手机号</el-button
      >
    </div>
    <div class="repairTrace-form" v-else>
      <div class="repairTrace-code-handle-btn">
        <!-- <div class="repairTrace-areaCode-warp">
          <span>+</span>
          <el-input
            class="repairTrace-areaCode-input"
            v-model.trim="areaCode"
            @keyup.enter.native="checkDetails"
          ></el-input>
        </div> -->

        <el-input
          v-model.trim="phone"
          oninput="value=value.replace(/[^\d]/g,'')"
          class="repairTrace-text-input"
          :placeholder="$t('placeholder.phone')"
          @keyup.enter.native="checkDetails"
          clearable
        ></el-input>
      </div>
      <div class="repairTrace-code-handle-btn">
        <el-input
          v-model.trim="code"
          ref="codeInput"
          oninput="value=value.replace(/[^\d]/g,'')"
          class="repairTrace-text-input"
          :placeholder="$t('placeholder.code')"
          @keyup.enter.native="checkDetails"
          clearable
        ></el-input>
        <el-button
          v-if="!isGetCode"
          class="gb-button code-btn"
          @click="getCode"
          >{{ $t("login.getCode") }}</el-button
        >
        <el-button v-else class="gb-button code-btn gb-button-disabled" disabled
          >{{ $t("common.resend") }}（{{ countdown }}）</el-button
        >
      </div>
      <!-- <p class="repairTrace-form-tips font-format-small regular-family">{{$t('elMsg.tips20')}}</p> -->
      <el-button
        class="repairTrace-form-btn white-color gb-button font-format-normal multiple-family"
        @click="checkDetails"
        >{{ $t("login.login") }}</el-button
      >
      <div class="repairTrace-oldData-tips">
        <p class="font-format-medium medium-family">
          因系统更新，2022年8月16日19:00前提交的数据请点击以下地址进行查询
        </p>
        （<a
          class="font-format-medium medium-family"
          href="https://send2boox.com/o/d/"
          target="_blank"
          >https://send2boox.com/o/d/</a
        >）
      </div>
    </div>
    <div class="repairTrace-main" v-if="currentToken">
      <!-- <p class="repairTrace-main-title font-format-big multiple-family">售后列表详情</p> -->
      <div class="repairTrace-main-card" v-if="orders && orders.length">
        <el-table
          :data="orders"
          row-key="_id"
          :expand-row-keys="defaultExpandRowKeys"
          height="100%"
        >
          <!-- <el-table-column type="expand">
            <template slot-scope="scope">
              <el-steps :active="scope.row.progress.length - 1" align-center>
                <el-step
                  v-for="item in scope.row.progress"
                  :key="item.id"
                  :title="item.desc"
                ></el-step>
              </el-steps>
            </template>
          </el-table-column> -->
          <el-table-column label="维修编号" prop="code" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="型号"
            prop="deviceModel"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.details.map((item) => item.model).join("/")
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="进度" prop="step" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ formatStepTitle(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="快递单"
                           prop="trackingNumber"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.trackingNumber ? scope.row.trackingNumber : '-'}}
            </template>
          </el-table-column> -->
          <el-table-column label="时间" prop="createdAt" show-overflow-tooltip>
            <!-- <template slot-scope="scope">
              {{ scope.row.createdAt }}
            </template> -->
          </el-table-column>
          <el-table-column label="操作" :align="'center'" width="200">
            <!-- <template slot-scope="scope">
              <el-button type="primary" @click="updateTrackingNumber(scope.row)"
                >更新快递单号</el-button
              >
            </template> -->
            <template slot-scope="scope">
              <!-- <el-button
                type="danger"
                size="mini"
                @click="updateRepairStatus(scope.row)"
                >取消申请
              </el-button> -->
              <el-button
                v-if="scope.row.status === -1"
                type="warning"
                size="mini"
                @click="updateRepair(scope.row)"
                >完善信息</el-button
              >
              <el-button
                v-if="scope.row.status === -1"
                type="danger"
                size="mini"
                @click="delRepair(scope.row)"
                >删除</el-button
              >
              <template v-else>
                <el-button
                  type="primary"
                  size="mini"
                  @click="checkRepairTrace(scope.row)"
                  >查看详情</el-button
                >
                <!-- <el-button
                  v-if="
                    scope.row.details
                      .filter((a) => a.repair)
                      .map((b) => b.repair.id).length
                  "
                  :loading="reportLoading"
                  type="primary"
                  size="mini"
                  @click="getPdfExport(scope.row)"
                  >维修报告</el-button
                > -->
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="repairTrace-noData" v-else>
        <img src="@/assets/imgs/icon_table_no_gift.svg" alt="" />
        <p class="table-empty-msg font-format-medium regular-family">
          暂无数据
        </p>
        <div class="repairTrace-oldData-tips">
          <p class="font-format-medium medium-family">
            因系统更新，2022年8月16日19:00前提交的数据请点击以下地址进行查询
          </p>
          （<a href="https://send2boox.com/o/d/" target="_blank"
            >https://send2boox.com/o/d/</a
          >）
        </div>
      </div>
    </div>

    <el-dialog
      title="更新快递单号"
      :visible.sync="dialogVisible"
      width="300px"
      center
    >
      <div class="repairTrace-dialog">
        <el-form
          :model="form"
          @submit.native.prevent
          label-position="left"
          ref="form"
          :rules="rules"
          :inline="false"
          size="normal"
        >
          <el-form-item label="快递单号" prop="trackingNumber">
            <el-input
              class="repairTrace-form-input"
              placeholder="请输入快递单号"
              @keyup.enter.native="submitForm('form')"
              v-model.trim="form.trackingNumber"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("common.cancel")
        }}</el-button>
        <el-button type="primary" @click="submitForm('form')">{{
          $t("common.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userInfo"]),
    rules() {
      let rules = {
        phone: [
          {
            required: true,
            message: this.$t("placeholder.phone"),
            trigger: "blur",
          },
        ],
        trackingNumber: [
          { required: true, message: "订单号不能为空", trigger: "blur" },
        ],
      };
      return rules;
    },
  },
  data() {
    return {
      phone: "",
      code: "",
      areaCode: "86",
      countdown: 60,
      isGetCode: false,
      initTime: null,
      activeNames: [],
      orders: [],
      defaultExpandRowKeys: [],
      selectOrder: null,
      dialogVisible: false,
      form: {
        trackingNumber: "",
      },
      keyCode: null,
      currentToken: "",
      reportLoading: false,
    };
  },
  methods: {
    formatStepTitle(status) {
      let title = "";
      switch (status) {
        case 0:
          title = `待签收`;
          break;
        case 1:
          title = `处理中`;
          break;
        case 2:
          title = `待付费`;
          break;
        case 3:
          title = `文石寄出`;
          break;
      }
      return title;
    },
    async getCode() {
      if (!this.checkPhoneParams()) return;
      this.countdownStart();
      this.isGetCode = true;
      let params = {
        phone: this.phone,
      };
      try {
        await this.$http.newSendMobileCode(params);
      } catch (error) {
        clearInterval(this.initTime);
        this.isGetCode = false;
        this.countdown = 60;
      }
    },

    countdownStart() {
      clearInterval(this.initTime);
      this.initTime = setInterval(() => {
        if (this.countdown === 1) {
          this.isGetCode = false;
          this.countdown = 60;
          clearInterval(this.initTime);
        } else {
          this.countdown -= 1;
        }
      }, 1000);
    },

    checkPhoneParams() {
      if (!this.phone || this.phone.indexOf(" ") !== -1) {
        this.elMsg(this.$t("elMsg.phoneEmpty"), "error");
        return false;
      }

      if (!this.areaCode || this.areaCode.indexOf(" ") !== -1) {
        this.elMsg(this.$t("elMsg.areaEmpty"), "error");
        return false;
      }

      return true;
    },

    checkCode() {
      this.code = this.$refs.codeInput.getInput().value;
      if (!this.code || this.code.indexOf(" ") !== -1) {
        this.elMsg(this.$t("elMsg.codeEmpty"), "error");
        return false;
      }
      return true;
    },

    async checkDetails() {
      if (!this.checkPhoneParams() || !this.checkCode()) return;
      try {
        await this.login();
        await this.getRepairReqList();
        this.elMsg(this.$t("elMsg.checkSuccess"), "success");
        this.code = "";
        this.phone = "";
        this.countdown = 60;
        this.isGetCode = false;
      } catch (error) {
        console.log(error);
      }
    },

    async login() {
      return new Promise(async (resolve, reject) => {
        let params = {
          phone: this.phone,
          code: this.code,
        };
        try {
          let res = await this.$http.suserLogin(params);
          this.$local.set("afterSaleToken", res.data);
          this.$cookie.set("afterSaleToken", res.data);
          this.currentToken = res.data;
          resolve("ok");
        } catch (error) {
          reject(error);
        }
      });
    },

    getRepairReqList() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.$http.getRepairReqList({ code: this.keyCode });
          if (!res.data.length) {
            this.elMsg("暂无数据", "warning");
            return;
          }
          this.orders = res.data.filter((item) => item.docStatus === 1);
          resolve("ok");
        } catch (error) {
          if (error.code === 11001) {
            this.clearStorage();
          }
          reject(error);
        }
      });
    },

    async updateRepairStatus(item) {
      const param = {
        ids: [item.id],
      };
      await this.$http.updateDocStatus(param);
      this.getRepairReqList();
    },

    updateRepair(item) {
      this.$router.push({
        name: "RepairReq",
        query: { ...this.$route.query, id: item.id },
      });
    },
    async delRepair(item) {
      await this.$confirm("是否要删除", "确定？", {
        confirmButtonText: this.$t("common.confirm"),
        cancelButtonText: this.$t("common.cancel"),
        showClose: false,
        center: true,
      });
      try {
        await this.$http.delRepair({ ids: [item.id] });
        this.orders = [];
        this.getRepairReqList();
        this.elMsg(this.$t("elMsg.delSuccess"), "success");
      } catch (error) {
        this.elMsg(this.$t("elMsg.delFailure"), "error");
      }
    },
    checkRepairTrace(item) {
      this.$router.push({
        name: "RepairTraceDetails",
        query: { ...this.$route.query, id: item.id },
      });
    },

    async getPdfExport(item) {
      try {
        this.reportLoading = true;
        let ids = item.details.filter((a) => a.repair).map((b) => b.repair.id);
        if (!ids.length) {
          this.$message({
            message: "当前还没生成维修报告",
            type: "warning",
          });
          return;
        }
        let res = await this.$http.getPdfExport({ ids });
        this.downloadFile(res.data);
      } catch (error) {
        this.reportLoading = false;
      }
    },

    downloadFile(url) {
      let filename = url.split("/").pop();
      const a = document.createElement("a");
      a.setAttribute("download", filename);
      a.setAttribute("href", `${location.origin}/${url}`);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      this.reportLoading = false;
    },

    clearStorage() {
      this.$local.remove("afterSaleToken");
      this.$local.remove("oId");
      this.$cookie.remove("afterSaleToken");
      this.currentToken = "";
      this.orders = [];
    },

    updateTrackingNumber(item) {
      this.selectOrder = item;
      this.dialogVisible = true;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    // this.keyCode = this.$route.query.s ? this.$route.query.s : null;
    this.currentToken = this.$local.get("afterSaleToken");
    if (this.currentToken) {
      this.getRepairReqList();
    }
  },
};
</script>

<style lang="scss">
.repairTrace-container {
  flex: 1;
  background: #fff;
  .repairTrace-header {
    padding: 0 10px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    > .repairTrace-logou {
      font-size: 16px;
    }
  }
  .repairTrace-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    .repairTrace-code-handle-btn + .repairTrace-code-handle-btn {
      margin-top: 20px;
    }
    .repairTrace-code-handle-btn {
      display: flex;
      width: 100%;
      max-width: 350px;
      min-width: 150px;
      overflow: hidden;
      /* border: 1px solid #eeeeee; */
      background: $mainColor;
      border-radius: $button-radius;
      height: 38px;
      line-height: 38px;
      > .el-button {
        border: 0 !important;
      }
      .repairTrace-areaCode-warp {
        display: flex;
        align-items: center;
        width: 65px;
        margin-left: 10px;
        border-right: 1px solid #eeeeee;
        > span {
          margin-bottom: 4px;
        }
        .repairTrace-areaCode-input {
          > .el-input__inner {
            background: transparent !important;
            padding: 0 5px;
            border: 0;
          }
        }
      }
      .repairTrace-text-input {
        > .el-input__inner {
          background: transparent !important;
          padding: 0 10px 0 15px;
          border: 0;
        }
      }
      .code-btn {
        height: 100%;
        background: $themeColor;
        border-radius: $button-radius;
        box-shadow: none;
        color: #fff;
      }
      .disabled-btn {
        color: #fff;
        border: 0;
        background: #d88364;
        @extend .code-btn;
      }
    }

    .repairTrace-form-tips {
      margin-top: 12px;
    }

    .repairTrace-form-btn {
      width: 100%;
      max-width: 350px;
      min-width: 150px;
      margin-top: 20px;
    }
  }
  .repairTrace-oldData-tips {
    text-align: center;
    margin-top: 20px;
    > p {
      color: red;
    }
    > a {
      color: red;
      text-decoration: underline;
      &:hover {
        color: $delBtnColor;
      }
    }
  }
  .repairTrace-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .repairTrace-noData {
      height: 100% !important;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 220px;
      background: #fff;
      box-shadow: $div-shadow;
      border-radius: $button-radius;
      margin-top: 20px;

      > .table-empty-msg {
        margin-top: 15px;
        color: #595959;
      }
    }
    .repairTrace-main-card {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: #fff;
      box-shadow: $div-shadow;
      border-radius: 4px;
      margin-top: 20px;
      .el-table__expanded-cell {
        padding: 20px 10px;
        .el-step__title {
          font-size: 14px;
        }
      }
    }
  }
}
.repairTrace-dialog {
  display: flex;
  overflow: hidden;
  > .el-form {
    width: 100%;
  }
  .repairTrace-form-input {
    > input {
      background: $menutBGColor;
      border-radius: $button-radius;
    }
  }
}
</style>
